// AR
export const availabilityPrices = {
  header: {
    title: "الإتاحة والأسعار",
  },
  common: {
    today: "اليوم",
    cancel: "إلغاء",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
  },
  pricelabs: {
    title: "تتم إدارة الأسعار بواسطة PriceLabs",
    text: "يتم تحديث الأسعار تلقائيًا ولا يمكن تعديلها يدويًا.",
  },
  topbar: {
    calendar: "التقويم",
    bulkEdit: "تعديل جماعي",
    configTitle: "إعدادات التقويم",
    syncSection: "المزامنة",
    resyncOta: "إعادة المزامنة مع OTA",
    resyncOtaDesc: "يعيد إرسال الإتاحة والأسعار إلى القناة.",
  },
  empty: {
    noHotelTitle: "لا توجد إعلانات من نوع فندق",
    noHotelDesc:
      "أنشئ إعلانًا من نوع <strong>فندق</strong> أو <strong>تخييم</strong> لبدء إدارة الإتاحة والأسعار.",
    goToListings: "الذهاب إلى الإعلانات",
    noRoomsTitle: "{name} لا يحتوي على غرف",
    noRoomsDesc:
      "لا يحتوي هذا الإعلان على أي غرف مسجّلة بعد. أضف وحدات من تفاصيل الإعلان لإدارة الإتاحة والأسعار.",
    configureListing: "إعداد الإعلان",
  },
  summary: {
    roomState: "حالة الغرفة",
    roomsForSale: "الغرف المتاحة للبيع",
    netBooked: "المحجوز الصافي",
  },
  state: {
    available: "متاح",
    closed: "مغلق",
    soldOut: "نفدت",
    pastLabel: "غير متاح",
  },
  calendar: {
    // التصريف (vue-i18n v8 عبر الأنابيب) — choiceIndex = عدد الغرف / الليالي
    roomsCount: "{count} غرفة | {count} غرف",
    minStayTooltip: "الحد الأدنى للإقامة: {count} ليلة | الحد الأدنى للإقامة: {count} ليالٍ",
  },
  offBadge: "مُوقفة",
  offTooltip: "البيع مُوقف: هذه التعرفة غير معروضة على أي قناة. وتبقى تعرفات الغرفة الأخرى معروضة للبيع.",
  rateMenu: {
    open: "خيارات التعرفة",
    minStay: "الحد الأدنى للإقامة حسب التواريخ",
    priceLabsMinStay: "تدير PriceLabs هذه التعرفة: وهي التي تحدد الحد الأدنى للإقامة.",
    stopSelling: "إيقاف بيع هذه التعرفة",
    stopping: "جارٍ إيقاف البيع…",
    resuming: "جارٍ إعادة تفعيل البيع…",
    resumeSelling: "استئناف بيع هذه التعرفة",
    derivedPriceHint: "سعر التعرفة المشتقة يأتي من التعرفة الرئيسية",
    mainKeepsDerived: "ستستمر التعرفات المشتقة منها في البيع",
    mainNotYet: "إغلاق تعرفة رئيسية غير متاح بعد",
  },
  derived: {
    badge: "م",
    tooltip: "سعر مشتق من: {parent}{rule}",
    rulePart: " · القاعدة: {rule}",
  },
  tooltips: {
    syncEnabled:
      "يعيد حساب الإتاحة والحد الأقصى للإقامة وإرسالهما إلى OTA (يمنع الحجز الزائد).",
    syncDisabled: "اربط العقار بقناة لتتمكن من المزامنة.",
    toggleClosedOpen: "تبديل مغلق/مفتوح",
    managedByPricelabs: "مُدار بواسطة PriceLabs",
    clickToEdit: "اختر أو انقر للتعديل",
  },
  cellTitle: {
    pastDate: "تاريخ ماضٍ",
    closed: "مغلق (انقر للفتح)",
    detail:
      "{free} متاحة · تعرض {tope} من {total} · {booked} محجوزة — انقر لتعديل الحد",
  },
  soldBadge: {
    confirmed: "{real} حجوزات مؤكدة",
    withOverbooking: "{real} مؤكدة + {over} حجز زائد",
  },
  bulkModal: {
    from: "من",
    to: "إلى",
    rangeHint:
      "يمكنك تعديل النطاق هنا لتوسيعه أو ضبطه. (سيحدّث العرض بصريًا الشهر الحالي فقط.)",
    room: "الغرفة",
    whatToEdit: "ما الذي تريد تعديله",
    optAvail: "الإتاحة والإغلاقات",
    optRate: "الأسعار والحد الأدنى للإقامة",
    status: "الحالة",
    open: "فتح",
    close: "إغلاق",
    cap: "الحد الأقصى",
    availHint:
      "هذا هو الإجمالي الذي تعرضه؛ تُخصم الحجوزات تلقائيًا ويُباع المتاح فقط. الحد الأقصى {max} (التشغيلية، بدون الصيانة).",
    mainRate: "السعر الرئيسي",
    mainRateHint:
      "اختر السعر الرئيسي المراد تغييره؛ تُضبط أسعاره المشتقة تلقائيًا.",
    action: "الإجراء",
    price: "السعر",
    minStay: "الحد الأدنى للإقامة",
    minStayNights: "الحد الأدنى للإقامة (ليالٍ)",
    minStayHelp: "1 = بدون قيود (مسح)",
  },
  syncConfirm: {
    title: "المزامنة مع OTA",
    message:
      "سيُعاد حساب الإتاحة والحد الأقصى للإقامة لهذا التقويم وإرسالهما إلى OTA.",
    confirm: "نعم، زامن",
  },
  progress: {
    processing: "جارٍ المعالجة…",
    syncing: "جارٍ مزامنة التقويم مع OTA…",
    updatingAvail: "جارٍ تحديث الإتاحة…",
    updatingRate: "جارٍ تحديث السعر…",
    applying: "جارٍ تطبيق التغييرات…",
    applyingBulk: "جارٍ تطبيق التعديل الجماعي…",
    applyingIn: "جارٍ التطبيق على {name}…",
  },
  toasts: {
    noPropertyToSync: "لا يوجد عقار للمزامنة.",
    syncOk: "تمت إعادة حساب التقويم ومزامنته مع OTA.",
    syncErr: "تعذّرت مزامنة التقويم مع OTA.",
    loadErr: "تعذّر تحميل معلومات الفندق.",
    maxAvailClosedBlocked:
      "الحد الأقصى المتاح: {capacity} (توجد غرف مغلقة أو محظورة أو قيد الصيانة).",
    availUpdated: "تم تحديث الإتاحة",
    availUpdateErr: "تعذّر تحديث الإتاحة",
    freeSuffix: " (المتاح: {free})",
    rateUpdated: "تم تحديث السعر",
    rateUpdateErr: "تعذّر تحديث السعر",
    maxAvailMaintenance:
      "الحد الأقصى المتاح: {capacity} (توجد غرف قيد الصيانة أو غير تشغيلية).",
    noDatesModifiedBooked: "لم يتم تعديل أي تاريخ: {count} به حجوزات.",
    appliedFreeDates:
      "تم التطبيق على التواريخ المتاحة. {count} تاريخ (تواريخ) بها حجوزات لم يتم تعديلها.",
    changesApplied: "تم تطبيق التغييرات بنجاح",
    savedNotSyncedYet: "حُفظ هنا، لكنه لم يصل بعد إلى قنوات البيع. ستتم إعادة المحاولة تلقائيًا خلال دقائق.",
    cannotEditDerivedPricelabs:
      "لا يمكن تعديل سعر مشتق أو مُدار بواسطة PriceLabs.",
    minStayNumberGte1: "يجب أن يكون الحد الأدنى للإقامة رقمًا >= 1.",
    invalidAction: "إجراء غير صالح.",
    applyErr: "تعذّر تطبيق التغييرات",
    noRoomsToEdit: "لا توجد غرف للتعديل.",
    selectAtLeastOneRoom: "اختر غرفة واحدة على الأقل.",
    chooseAction: "اختر إجراءً.",
    selectDateRange: "اختر نطاقًا زمنيًا.",
    enterValidPrice: "أدخل سعرًا صالحًا.",
    minStayGte1: "يجب أن يكون الحد الأدنى للإقامة >= 1.",
    appliedWithErrors: "تم التطبيق على {ok} غرفة (غرف). {failed} بها خطأ",
    noDatesModifiedCapacity:
      "لم يتم تعديل أي تاريخ: {count} يوم (أيام) لم تسمح بهذا العدد من الغرف.",
    bulkAppliedClamped:
      "تم تطبيق التعديل الجماعي على {ok} غرفة (غرف). في {clamped} تاريخ (تواريخ) تم ضبطه إلى عدد الغرف قيد الخدمة.",
    bulkApplied: "تم تطبيق التعديل الجماعي على {ok} غرفة (غرف).",
    bulkApplyErr: "تعذّر تطبيق التعديل الجماعي.",
    applyChangesErr: "تعذّر تطبيق التغييرات.",
  },
  // محتوى زخرفي (aria-hidden) لحالة الفراغ
  ghost: {
    month: "مايو 2026",
    day1: "الإثنين 1",
    day2: "الثلاثاء 2",
    day3: "الأربعاء 3",
    day4: "الخميس 4",
    day5: "الجمعة 5",
    day6: "السبت 6",
    day7: "الأحد 7",
    day8: "الإثنين 8",
    day9: "الثلاثاء 9",
    day10: "الأربعاء 10",
    day11: "الخميس 11",
    day12: "الجمعة 12",
    unit1: "جناح ديلوكس",
    unit1Rooms: "(2 غرفة)",
    unit2: "غرفة قياسية",
    unit2Rooms: "(3 غرف)",
    baseRate: "السعر الأساسي",
    nonRefundable: "غير قابل للاسترداد",
  },
};
